// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.back-btn[data-v-1fa776da] {\n  width: -moz-fit-content;\n  width: fit-content;\n  color: var(--sea);\n  cursor: pointer;\n  font-size: 0.94rem;\n}\na.back-btn[data-v-1fa776da]:hover {\n  color: var(--green);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
